import "../../assets/NumberSpinner.css";
import { defineComponent as f, ref as v, watch as b, openBlock as y, createElementBlock as _, createElementVNode as l, createVNode as i, withDirectives as x, vModelText as w } from "vue";
import g from "../icons/IconMinus.js";
import h from "../icons/IconPlus.js";
import { _ as k } from "../../_plugin-vue_export-helper-dad06003.js";
const L = { class: "inline-flex overflow-hidden rounded-lg border" }, V = { class: "p-1" }, N = ["aria-label", "title", "disabled"], A = ["min", "max", "step", "aria-label"], B = { class: "p-1" }, I = ["aria-label", "title", "disabled"], z = /* @__PURE__ */ f({
  __name: "NumberSpinner",
  props: {
    modelValue: {},
    min: { default: void 0 },
    max: { default: void 0 },
    step: { default: 1 },
    inputLabel: { default: void 0 },
    decreaseLabel: { default: void 0 },
    increaseLabel: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(r, { emit: s }) {
    const t = r, e = v(t.modelValue);
    b(
      () => t.modelValue,
      (a) => {
        e.value = a;
      }
    );
    const d = () => {
      typeof e.value == "string" ? e.value = t.min || 1 : e.value = e.value - t.step, n();
    }, u = () => {
      typeof e.value == "string" ? e.value = t.min ? t.min + t.step : 1 : e.value = e.value + t.step, n();
    }, m = (a) => [
      "Tab",
      "Backspace",
      "Enter",
      "Delete",
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight"
    ].includes(a.key) || !isNaN(parseInt(a.key)), p = () => {
      typeof e.value == "string" && (e.value = t.min || 1, n());
    }, n = () => {
      typeof e.value != "string" && (t.max && e.value >= t.max && (e.value = t.max), typeof t.min < "u" && e.value <= t.min && (e.value = t.min), s("update:modelValue", e.value));
    };
    return (a, o) => (y(), _("div", L, [
      l("div", V, [
        l("button", {
          type: "button",
          class: "flex size-12 items-center justify-center rounded-md border-0 bg-white text-center text-xl text-gray-darkest outline-2 outline-primary/30 active:outline active:outline-primary/90",
          "aria-label": a.decreaseLabel,
          title: a.decreaseLabel,
          disabled: e.value === a.min,
          onClick: d
        }, [
          i(g)
        ], 8, N)
      ]),
      x(l("input", {
        "onUpdate:modelValue": o[0] || (o[0] = (c) => e.value = c),
        type: "number",
        inputmode: "numeric",
        autocomplete: "off",
        class: "focus:shadow-0 m-0 w-12 appearance-none border-0 p-0 text-center text-[20px] font-semibold text-gray-darkest shadow-none outline-none focus:outline-0 focus:ring-0",
        min: a.min,
        max: a.max,
        step: a.step,
        pattern: "\\d*",
        "aria-label": a.inputLabel,
        onkeydown: m,
        "aria-live": "polite",
        onBlur: p,
        onKeyup: n
      }, null, 40, A), [
        [w, e.value]
      ]),
      l("div", B, [
        l("button", {
          type: "button",
          class: "flex size-12 items-center justify-center rounded-md border-0 bg-white text-center text-xl text-gray-darkest outline-2 outline-primary/30 active:outline active:outline-primary/90",
          "aria-label": a.increaseLabel,
          title: a.increaseLabel,
          disabled: e.value === a.max,
          onClick: u
        }, [
          i(h)
        ], 8, I)
      ])
    ]));
  }
});
const j = /* @__PURE__ */ k(z, [["__scopeId", "data-v-bd993d03"]]);
export {
  j as default
};
